import { CSSProperties, ReactNode, useState } from 'react'
import styles from '~/styles/atoms/tab/tab.module.scss'

import Tab, { TabType } from '~/components/atoms/tab/Tab'
import { TabItemVars } from '~/components/atoms/tab/TabItem'
import { addClass } from '~/common/utils/html'

interface Props {
  items: TabItemVars[]
  contents: ReactNode[]
  type?: TabType
}

const columnWidth = (type: TabType) => {
  switch (type) {
    case TabType.SUPPORT:
      return 300
    default:
  }
  return 520
}

const TabSwitch = ({items, contents, type = TabType.NORMAL}: Props) => {
  const [selected, setSelected] = useState<number>(0)
  const transition: CSSProperties = {
    transform: 'translateX(' + -selected * columnWidth(type) + 'px)'
  }

  return (
    <div className={styles.switch + addClass(styles.switch__normal, type == TabType.NORMAL)}>
      <Tab items={items} selected={selected} onSelect={setSelected} type={type}/>
      <div className={styles.switch__content}>
        <ul className={styles.switch__content__list} style={transition}>
          {contents.map((content, index) =>
            <li key={index} className={styles.switch__content__item}>{content}</li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default TabSwitch